module.exports = __webpack_public_path__ + "media/assets/images/common/logo-horizontal-cf9b1ac6ced69a83e5159a53bf074c7a.png";